<template>
  <div
    class="bg-white list-card p-2"
    :class="[hasStepGuide ? (onlyOnePaymentMethod ? 'top-up-on-step' : 'top-up-on-step border-content') : 'top-up-form-container', hasStepGuide && isTeeXcorpPlatform ? 'border-content' : '']"
  >
    <!-- topup -->
    <div
      class="add-fund-form"
    >
      <validation-observer
        ref="amountValidation"
        v-slot="{ invalid }"
      >
        <b-form
          class="amount-form"
          @submit.prevent=""
        >
          <div class="d-block d-md-flex justify-content-between align-items-center">
            <h3>{{ $t('SMB.payment.titleAddFund') }}</h3>
          </div>
          <p>{{ $t('SMB.payment.subTitleAddFund') }}</p>
          <b-form-group
            :label="$t('SMB.payment.labelAmountInput')"
            class="position-relative form-label"
          >
            <validation-provider
              #default="{ errors }"
              id="amount"
              :name="$t('SMB.payment.amount')"
              :rules="{
                required,
                integerNumber,
                greaterThanZero,
                amountNumberVN,
                rangeTopUp: { min: minTopUp },
              }"
            >
              <b-input-group
                class="input-group-merge width-custom w-100"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-input-group-prepend is-text>
                  <feather-icon icon="DollarSignIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model.number="paymentAmount"
                  data-testid="input-local-bank-amount"
                  class="input-height"
                  autofocus
                  type="number"
                  placeholder="EX: 2500"
                  :state="errors.length > 0 ? false : null"
                  @keyup="currentIndex = null"
                  @input="onChangeCurrentPaymentAmount"
                />

                <b-input-group-append
                  v-if="paymentAmount === maxAmount"
                  is-text
                >
                  <img
                    :src="
                      require('@/assets/images/pages/payment/ic-max.svg')
                    "
                    alt="image"
                  >
                </b-input-group-append>
              </b-input-group>
              <small
                v-if="isDirty && !paymentAmount && paymentAmount !== 0"
                class="text-danger d-block"
                style="margin-top: 10px"
              >
                {{ $t('SMB.payment.errorAddAmount') }}
              </small>
              <small
                v-else-if="errors[0]"
                class="text-danger d-block"
                style="margin-top: 10px"
              >
                {{ errors[0] }}
              </small>
              <small
                v-if="!errors[0] && paymentAmount"
                class="d-flex align-items-center"
                style="margin-top: 10px"
              >
                <b-img
                  class="icons-tick"
                  fluid
                  style="margin-right: 5px"
                  :src="require('@/assets/images/icons/icon-tick.svg')"
                  alt="guide"
                />
                {{ $t('SMB.payment.amountValid') }}
              </small>
              <div class="info-box d-flex align-items-center">
                <feather-icon
                  v-b-tooltip.v-light="{id: 'tooltip-local-bank-limit-amount', title: `${$t('SMB.payment.textMaxAmount')}`}"
                  icon="HelpCircleIcon"
                  size="12"
                  class="icon-info"
                />
              </div>
            </validation-provider>
          </b-form-group>
          <div
            class="
                  d-flex
                  align-items-md-center
                  flex-wrap
                  max-width
                "
          >
            <div
              v-for="(item, index) in amountItem"
              :key="index"
              :id="`amount-${item.value}`"
              class="btn-amount"
              :class="{ active: currentIndex === index }"
              @click="() => choosePaymentAmount(item, index)"
            >
              <span>${{ item.value }}</span>
            </div>
          </div>

          <div
            v-if="hasAMId && tipMode"
            class="mt-2"
          >
            <b-form-checkbox
              v-model="showTipsForAM"
              :aria-expanded="showTipsForAM ? 'true' : 'false'"
              aria-controls="collapse-1-inner"
              data-testid="checkbox-show-tips-input"
              @input="handleShowTipsInput"
            >
              <span class="cursor-pointer">{{ $t('payment.txtCheckboxShowTipsForAM') }}</span>
            </b-form-checkbox>
          </div>

          <b-collapse
            v-model="showTipsForAM"
            id="collapse-1-inner"
            class="mt-2"
          >
            <b-form-group
              class="position-relative form-label"
              label-for="tip-amount"
            >
              <validation-provider
                #default="{ errors }"
                id="tip"
                name="tip"
                :rules="{
                  positive,
                  rangeTipAmount: { min: minTipAmount },
                }"
              >
                <b-input-group
                  class="input-group-merge width-custom w-100"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-input-group-prepend is-text>
                    <feather-icon icon="DollarSignIcon" />
                  </b-input-group-prepend>
                  <cleave
                    v-model.number="tipAMAmount"
                    id="local-bank-tip-amount"
                    data-testid="local-bank-tip-amount"
                    class="form-control"
                    :placeholder="$t('payment.creditCard.placeholderTip')"
                    :options="cleaveOptions"
                    :state="errors.length > 0 ? false : null"
                    @keyup.native="onChangeTipAmount"
                  />
                </b-input-group>
                <small
                  v-if="errors[0]"
                  id="error-tip-amount-local-bank"
                  data-testid="error-tip-amount-local-bank"
                  class="text-danger"
                >
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>
            <div
              class="
              d-flex
              align-items-md-center
              flex-wrap
              max-width
            "
            >
              <div
                v-for="(item, index) in tipItem"
                :key="index"
                :id="`local-bank-tip-item-${index+1}`"
                :data-testid="`local-bank-tip-item-${index+1}`"
                class="btn-tip"
                :class="{ active: currentTipIndex === index+1 }"
                @click="chooseTipAmount({item, index})"
              >
                <span>{{ item.value === $t('payment.textNoTip') ? item.value : `${item.value}%` }}</span>
              </div>
            </div>
          </b-collapse>

          <p
            class="mt-1 mb-0"
            data-testid="local-bank-exchange-rate"
          >
            ~ 1 USD = {{ localStringFormat(USDToVNDRate) }} VNĐ
          </p>

          <div class="d-flex justify-content-end">
            <btn-loading
              id="trigger-continue-local-bank"
              data-testid="trigger-continue-local-bank"
              span-id="trigger-continue-local-bank-child"
              class="d-block mt-2 btn-height btn-text-color"
              variant-convert="btn-submit"
              pill
              :disabled="invalid"
              :loading="loading"
              @click="handleClickContinue"
            >
              {{ $t('SMB.payment.textGetInfoPayment') }}
            </btn-loading>
          </div>
        </b-form>
      </validation-observer>
    </div>
    <!-- /topup -->

    <!-- Horizontal-divide -->
    <div class="d-flex justify-content-center px-0 line-center">
      <div class="horizontal-divide" />
    </div>
    <!-- /Horizontal-divide-->

    <!-- Card summary -->
    <div class="mt-2 pl-0 summary-form">
      <local-bank-summary
        :amount="paymentAmount || 0"
        :amount-tip="tipAMAmount || 0"
        :current-tip="currentTip || 0"
        :show-tips-input="showTipsForAM"
      />
    </div>
    <!-- /Card summary-->
  </div>
</template>

<script>
import {
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormGroup,
  BForm,
  BImg,
  VBTooltip,
  BInputGroupAppend,
  BFormCheckbox,
  BCollapse,
  VBToggle,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import paymentMixin from '@/mixins/paymentMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import numberFormatMixin from '@/mixins/numberFormatMixin'
import billingMixin from '@/mixins/billingMixin'
import LocalBankSummary from '@/views/payment/components/LocalBank/LocalBankSummary.vue'

import { PAYMENT_CHILD_AMOUNT, PAYMENT_CHILD_TYPE, PERCENT_TIP_AMOUNT } from '@/constants'

// plugins
import { createNamespacedHelpers } from 'vuex'
// validation
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required,
  integerNumber,
  rangeTipAmount,
  positive,
  greaterThanZero,
  rangeTopUp,
  amountNumberVN,
} from '@validations'
import _get from 'lodash/get'
import Cleave from 'vue-cleave-component'
import envMixin from '@/mixins/envMixin'

const { mapGetters } = createNamespacedHelpers('payment')
const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')
const { mapGetters: mapGettersAds } = createNamespacedHelpers('adsAccount')

export default {
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BFormGroup,
    BImg,
    BInputGroupAppend,
    BtnLoading,
    LocalBankSummary,
    Cleave,
    BFormCheckbox,
    BCollapse,

    // validation
    ValidationProvider,
    ValidationObserver,
  },

  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
  },

  mixins: [paymentMixin, generalConfigsMixin, numberFormatMixin, billingMixin, stepGuideMixin, envMixin],

  props: {
    amountSelected: {
      type: Number,
      default: 0,
    },

    amountTip: {
      type: Number || null,
      default: null,
    },

    tipIndex: {
      type: Number,
      default: 0,
    },

    percentageTip: {
      type: Number || null,
      default: null,
    },
  },

  data() {
    return {
      showTipsForAM: false,
      // validation
      required,
      integerNumber,
      rangeTipAmount,
      positive,
      rangeTopUp,
      greaterThanZero,
      amountNumberVN,

      paymentAmount: this.amountSelected === 0 ? '' : this.amountSelected,
      currentPaymentAmount: {
        value: this.amountSelected,
        type: PAYMENT_CHILD_TYPE.NUMBER,
      },
      currentIndex: PAYMENT_CHILD_AMOUNT.findIndex(
        item => item.value === this.amount,
      ),
      isDirty: false,

      tipItem: PERCENT_TIP_AMOUNT,
      currentTipIndex: this.tipIndex || null,
      currentTip: this.percentageTip || null,
      tipAMAmount: this.amountTip !== null ? this.amountTip : null,

      cleaveOptions: {
        numeral: true,
        numeralPositiveOnly: true,
        numeralThousandsGroupStyle: 'none',
      },
      minTipAmount: 0,
    }
  },

  computed: {
    ...mapGetters(['message', 'status', 'loading']),
    ...mapGettersAuth(['user']),
    ...mapGettersAds(['listAccount']),

    listAccounts() {
      return _get(this.listAccount, ['content'], [])
    },

    maxAmount() {
      return 100000
    },

    checkHasNextBtn() {
      return this.hasStepGuide && this.user?.data?.balance > 0
    },
  },
  watch: {
    paymentAmount: {
      handler() {
        this.isDirty = true
      },
    },
  },

  methods: {
    handleShowTipsInput() {
      if (!this.showTipsForAM) {
        this.tipAMAmount = null
        this.onChangeTipAmount()
      }
    },

    onChangeTipAmount() {
      this.currentTipIndex = null
      this.currentTip = null
    },

    onChangeCurrentPaymentAmount() {
      if (this.currentTip) {
        this.tipAMAmount = ((this.currentTip * this.paymentAmount) / 100)
      }
    },

    chooseTipAmount(data) {
      this.currentTip = data.item.value === this.$t('payment.textNoTip') ? null : data.item.value
      this.tipAMAmount = ((this.currentTip * this.paymentAmount) / 100)
      this.currentTipIndex = data.index + 1
    },

    choosePaymentAmount(data, index) {
      this.paymentAmount = data.value
      this.currentIndex = index

      if (this.currentTip) {
        this.tipAMAmount = ((this.currentTip * data.value) / 100)
      }

      this.$nextTick(() => {
        this.$refs.amountValidation.validate()
      })
    },

    handleClickContinue() {
      if (this.noPlan) {
        this.$router.push('/billing')
      } else {
        if (!this.paymentAmount) {
          return
        }
        this.$emit('submit', { amount: this.paymentAmount, tipAMAmount: this.tipAMAmount })
      }
    },
  },
}
</script>
<style lang="scss">
.is-invalid {
  #tip-amount:not(:focus) {
    border-color: #e11c4e !important;
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";
.border-content {
  border-radius: 0px 0px 24px 24px !important;
}

.top-up-on-step {
  .line-center {
    display: none;
  }
}

.top-up-form-container{
  display: flex;
  //width: 850px;
  //margin: 0 auto;

  @media (max-width: 991px){
    width: 100%;
  }

  .add-fund-form{
    width: 50%;

    @media (max-width: 768px){
      width: 100%;
    }
  }

  .line-center{
    margin: 0 1.5rem;
  }

  .summary-form{
    width: 50%;
  }

  @media (max-width: 768px){
    display: block;

    .add-fund-form{
      max-width: 100%;
    }

    .line-center{
      display: none;
    }

    .summary-form{
      width: 100%;
    }
  }
}

.btn-amount, .btn-tip {
  padding: 6px 12px;
  margin-right: 10px;
  margin-top: 10px;

  border: 1px solid #e0e0e5;
  background-color: white;
  border-radius: 6px;

  cursor: pointer;

  color: #3d405b;
  font-size: 14px;

  &:hover,
  &.active {
    border: 1px solid $primary;
    color: $primary;
    font-weight: 600;
  }

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
}

.max-width {
  max-width: 410px;
}

.form-label {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
}

.list-card {
  border-radius: var(--border-radius-base);
}
</style>
